export const contentTableConfig = {
  title: '持续访问记录',
  propList: [
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      minWidth: '80',
      slotName: 'consumer',
      align: 'left'
    },
    {
      prop: 'channelName',
      label: '直播间',
      minWidth: '80',
      slotName: 'channel'
    },
    {
      prop: 'deptName',
      label: '所属部门',
      minWidth: '80',
      slotName: 'dept'
    },
    {
      prop: 'empName',
      label: '所属员工',
      minWidth: '80',
      slotName: 'emp'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
